import React from "react";
import { FlaskConical, TestTube } from "lucide-react";

export default function SearchModeIcon({
  modeId,
  className = "",
  strokeWidth = 1.9,
}) {
  if (modeId === "pro") {
    return (
      <FlaskConical
        className={className}
        aria-hidden="true"
        strokeWidth={strokeWidth}
      />
    );
  }

  return (
    <TestTube
      className={className}
      aria-hidden="true"
      strokeWidth={strokeWidth}
    />
  );
}
